type Props = {
  children: React.ReactNode;
};

export const CommentMenuButtonContainer: React.FC<Props> = ({ children }: Props) => {
  return <div>{children}</div>;
};
